module.exports = __webpack_public_path__ + "img/im_scrollfeature_01@2x.739d2f2a.jpg";